export default __webpack_public_path__ + "static/media/landlord-info.1f58ac6e.gif";